export default class Tabs {
	static init() {
		Array.from(document.querySelectorAll('.tabs')).forEach(element => {
			new Tabs(element);
		});
	}

	classes = {
		node: 'tabs',
		tabTargetItems: 'tabs__target-item',
		tabContentItems: 'tabs__content-item',
		tabTargetItemActive: 'tabs__target-item--is-active',
		tabContentItemActive: 'tabs__content-item--is-active'
	}
	tabs = [];

	constructor(element) {
		if (!element) return;

		this.node = element;
		this.id = this.node.id;

		this.parse();
		this.magicLine = new MagicLine('#' + this.id + ' .' + this.classes.tabTargetItems);
	}

	parse() {
		let tabTargets = this.node.querySelectorAll('.' + this.classes.tabTargetItems);
		Array.prototype.forEach.call(tabTargets, el => {
			this.tabs.push(new Tab(this, el));
		});
	}

	getActiveTab() {
		return this.tabs.find(el => el.isActive);
	}

	switchActiveTabTo(tab) {
		this.getActiveTab().setInactive();
		tab.setActive();
	}
}

class Tab {
	constructor(main, targetNode) {
		if (!main || !targetNode) return;

		this.main = main;
		this.targetNode = targetNode;
		this.isActive = this.targetNode.classList.contains(this.main.classes.tabTargetItemActive);
		this.id = this.targetNode.dataset.id;
		this.contentNode = this.main.node.querySelector('.' + main.classes.tabContentItems + '[data-id="' + this.id + '"]');

		this.targetNode.addEventListener('click', () => this.id !== this.main.getActiveTab().id ? this.main.switchActiveTabTo(this) : null);
	}

	toggleActive() {
		this[this.isActive ? 'setInactive' : 'setActive']();
	}

	setActive() {
		if (this.isActive) return;
		this.isActive = true;
		this.targetNode.classList.add(this.main.classes.tabTargetItemActive);
		this.contentNode.classList.add(this.main.classes.tabContentItemActive);
	}

	setInactive() {
		if (!this.isActive) return;
		this.isActive = false;
		this.targetNode.classList.remove(this.main.classes.tabTargetItemActive);
		this.contentNode.classList.remove(this.main.classes.tabContentItemActive);
	}
}

class MagicLine {
	classes = {
		main: 'magic-line',
		active: 'magic-line--is-over-active',
		activeItem: '--is-active' // active item class should contain this part
	}
	position = {
		top: 0,
		left: 0,
	}
	size = {
		height: 0,
		width: 0,
	}

	constructor(itemsSelector) {
		if (!itemsSelector) return;

		this.items = document.querySelectorAll(itemsSelector);
		this.node = this.create();
		this.isActive = false;

		window.addEventListener('load', () => {
			this.render(this.node);
			this.move(this.getActiveItem());
		});

		Array.prototype.forEach.call(this.items, el => {
			el.addEventListener('mouseenter', e => {
				this.move(e.target);
			});

			el.addEventListener('mouseleave', e => {
				this.move(this.getActiveItem());
			});
		});
	}

	create() {
		let magicLine = document.createElement(this.getActiveItem().tagName);
		magicLine.classList.add(this.classes.main);

		return magicLine;
	}

	render(node) {
		this.setProps(this.getActiveItem()); // initial position and size
		this.getActiveItem().parentNode.appendChild(node);
	}

	move(itemNode) {
		this.setProps(itemNode);
		this.node.style.cssText = `
		height: ${Math.trunc(this.size.height)}px;
		width: ${Math.trunc(this.size.width)}px;
		top: ${Math.trunc(this.position.top)}px;
		left: ${Math.trunc(this.position.left)}px;`;

		this.toggleActive(itemNode);
	}

	setProps(itemNode) {
		let newSize = itemNode.getBoundingClientRect();
		let newPosition = {
			top: itemNode.offsetTop,
			left: itemNode.offsetLeft
		}
		if (this.size.height !== newSize.height) this.size.height = newSize.height;
		if (this.size.width !== newSize.width) this.size.width = newSize.width;
		if (this.position.top !== newPosition.top) this.position.top = newPosition.top;
		if (this.position.left !== newPosition.left) this.position.left = newPosition.left;
	}

	isActiveItem(item) {
		return item.className.indexOf(this.classes.activeItem) >= 0;
	}

	toggleActive(item) {
		this[this.getActiveItem().isSameNode(item) ? 'setActive' : 'setInactive']();
	}

	setActive() {
		if (this.isActive) return;
		this.isActive = true;
		this.node.classList.add(this.classes.active);
	}

	setInactive() {
		if (!this.isActive) return;
		this.isActive = false;
		this.node.classList.remove(this.classes.active);
	}

	getActiveItem() {
		return Array.prototype.find.call(this.items, el => el.className.indexOf(this.classes.activeItem) > 0);
	}
}